<template>
	<footer id="footer" class="row">
		<div class="col-12">
			<div class="container">
				<div class="row">
					<div class="col-12 col-md-6">
					<router-link :to="{name:'home'}" class="logo">
						<img :src="require('../assets/img/Cherrytree-full-white.png')" alt="Cherrytree Logo">
					</router-link><br>
						<a target="_blank" href="https://www.google.co.nz/maps/place/Cherrytree+-+Wholesale%2B+Prices+Every+Day/@-41.2407352,174.8114689,17z/data=!3m1!4b1!4m5!3m4!1s0x6d38add499a26709:0x349c6aebb27ee72e!8m2!3d-41.2407393!4d174.8136576" class="footerLinks">Showroom & Shop</a><br>
						119-121 Main Street,<br>
						Upper Hutt Central, <br>
						Upper Hutt 5018<br>
						Phone: <a href="tel:0800243779" class="footerLinks">0800 243 779</a><br>
						Email: <a href="mailto:info@cherrytree.co.nz" class="footerLinks">info@cherrytree.co.nz</a><br>
					</div>
					<div class="col-12 col-md-3 mt-4 mt-md-0">
						<h2 class="h4">MENU</h2>
						<ul class="bottomNav">
							<li><router-link :to="{name:'terms-and-conditions'}" class="footerLinks">Terms & Conditions</router-link></li>
							<li><router-link :to="{name:'pledge'}" class="footerLinks">Membership Agreement</router-link></li>
							<li><router-link :to="{name:'warranty-and-returns'}" class="footerLinks">Warranty and Returns</router-link></li>
							<li><router-link :to="{name:'about-faq'}" class="footerLinks">FAQs</router-link></li>
							<li><router-link :to="{name:'privacy-policy'}" class="footerLinks">Privacy Policy</router-link></li>
							<li><router-link :to="{ name: 'opening-hours' }" class="footerLinks">Wellington Showroom Opening Hours</router-link></li>
						</ul>
						<h2 class="h4">OPPORTUNITIES</h2>
						<ul class="bottomNav">
							<li><router-link :to="{name:'become-a-supplier'}" class="footerLinks">Become a Supplier</router-link></li>
						</ul>
					</div>
					<div class="col-12 col-md-3">
						<h2 class="h4">WE ACCEPT</h2>
						<img class="footer-image" :src="require('../assets/img/Mastercard.jpg')" alt="Mastercard Logo">
						<img class="footer-image" :src="require('../assets/img/VISA.jpg')" alt="Visa Logo">
						<img class="footer-image" :src="require('../assets/img/Qcard.jpg')" alt="Qcard">
						<img class="footer-image" :src="require('../assets/img/gem-visa-card.jpg')" alt="Gem Visa Card">

					</div>
				</div>
				<hr class="d-none d-md-block"/>
				<div class="row justify-content-between" style="padding-bottom:10px">
					<div class="col-auto">{{new Date().getFullYear()}} &copy; Cherrytree. Designed &amp; Developed by Simon J Partridge. Design by Media Giant.</div>
					<div class="col-auto">
						<a target="_blank" href="https://www.instagram.com/cherrytreeshopping/"><InstagramLogo class="socialIcon"/><span class="d-none">Instagram Page</span></a>
						<a target="_blank" href="https://www.facebook.com/CherrytreeShopping/"><FacebookLogo class="socialIcon"/><span class="d-none">Facebook Page</span></a>
						<a target="_blank" href="https://m.youtube.com/watch?v=eFu4HylilD8"><YoutubeLogo class="socialIcon"/><span class="d-none">Youtube Channel</span></a>
					</div>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>

import InstagramLogo from "@/assets/img/instagram.svg"
import FacebookLogo from "@/assets/img/facebook.svg"
import YoutubeLogo from "@/assets/img/youtube.svg"

export default {
	name: 'ThePageFooter',
	components:{
		InstagramLogo,
		FacebookLogo,
		YoutubeLogo
	}
}
</script>

<style lang="scss">
#footer {
	padding-top:30px;
	color:white;
	margin-top:auto; //cause footer to sit at bottom of screen
	background:$CTdarkgrey;
}

.footerLinks {
	text-decoration: underline;
	color: white;
	&:hover {
		color: darken(white, 20%);
	}
}

.logo img{
	width:100%;
	max-width:300px;
}

.bottomNav{
	list-style-type: none;
	padding:0;
}

.socialIcon{
	width:20px;
	height:20px;
	fill:white;
	color:white;
	margin:5px;
}

.footer-image{
	width: 100px;
	// display: block;
	margin: 0 20px 20px 0;
	border: 1px solid #fff;
	border-radius: 5px;

}

</style>
